import { useMutation } from "@tanstack/react-query";

import { getApiErrorMessage } from "~/api/apiError";
import { useToast } from "~/components/ui/use-toast";
import { useNavigationHistoryStore } from "~/lib/stores/navigationHistory";

import { ApiClient } from "../api-client";

export function useLogoutUser() {
  const { toast } = useToast();
  const clearHistory = useNavigationHistoryStore((state) => state.clearHistory);

  return useMutation({
    mutationFn: async () => {
      const response = await ApiClient.api.authControllerLogout();
      return response.data;
    },
    onSuccess: () => {
      clearHistory();

      // No publicar `currentUser=null` dentro del árbol admin: eso hacía que el shell autenticado
      // se re-renderizara como público durante un frame. Limpiamos persistencia y hacemos un
      // reemplazo de documento; el estado en memoria muere con la página.
      window.localStorage.removeItem("auth-storage");
      window.localStorage.removeItem("current-user-storage");
      window.localStorage.removeItem("cart-storage");
      window.sessionStorage.removeItem("navigation-history");
      window.location.replace("/");
    },
    onError: (error) => {
      toast({
        variant: "destructive",
        description: getApiErrorMessage(error),
      });
    },
  });
}
